import api from 'Application/api/api';

const passwordVerifyAuthenticityForDirectProcedure = (
    driverLicenseControlId,
    password,
    cancelToken = null,
) =>
    api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/direct-check/password-verify-authenticity`,
        {
            password,
        },
        {
            cancelToken,
        },
    );

export default passwordVerifyAuthenticityForDirectProcedure;
